import BaseController from '../BaseController';
import Controller, { OnAfterFetch, OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { Inject } from '@odinjs/odin';
import { AboutBox, BaseModalProps, ManifestDependencies, ModalService, PanelAPI, TextAPI, ThemeTonalRange } from '@philips-internal/oswald-ui-components';
import { LayoutData } from '../../app/types';
import { FooterAliases, LoginLandingPageAliases } from '../../codegen';
import { FetchEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { isMobile } from '@philips-internal/oswald-ui-utils';
import React, { ReactElement } from 'react';
import { LoginAPI } from '@philips-internal/oswald-ui-foundation/lib/components';
import ConfigurationService from '../../services/configuration-service';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';

 type NetWorkProps = {
   dsLinkFacebook: string,
   dsLinkInstagram: string,
   dsLinkLinkedin: string,
   dsLinkTwitter: string,
   dsLinkYoutube: string
 }

@Controller({ fragment: 'footer' })
class FooterController extends BaseController {

  @Inject('address-text')
    addressText!: TextAPI;

  @Inject('email-text')
    emailText!: TextAPI;

  @Inject('emailTitle-text')
    emailTitle!: TextAPI;

  @Inject('phoneTitle-text')
    phoneTitle!: TextAPI;

  @Inject('phone-text')
    phoneText!: TextAPI;

  @Inject(FooterAliases.SOCIAL_PANEL)
    socialPanelApi!: PanelAPI;

  @Inject(LoginLandingPageAliases.LOGIN_LANDING_PAGE_LOGIN)
    loginApi!: LoginAPI;

  @OnMount({ target: FooterAliases.FOOTER_LAYOUT })
  onMountFooterLayout(): void {
    ConfigurationService.getConfigurationData().then((layoutData: LayoutData) => {
      setTimeout(() => {
        this.setFooterText(layoutData);
      });
    });
  }

  @OnAfterFetch({target:FooterAliases.SOCIAL_FETCH})
  onSocialFetch(evt: FetchEvent):void{
    const netWorkProps = evt.data as NetWorkProps;
    if(!netWorkProps.dsLinkFacebook && !netWorkProps.dsLinkInstagram && !netWorkProps.dsLinkTwitter&& !netWorkProps.dsLinkYoutube && !netWorkProps.dsLinkLinkedin){
      this.socialPanelApi.setVisible(false);
    }
  }

  @OnClick({ target: FooterAliases.LINK_VERSION })
  onClickLinkVersion(): void {
    const defaultTitleLogin = MessageService.translate('patient.welcome.landing.page').concat(' ').concat(MessageService.translate('patient.title.landing.page'));
    this.configureModalProps(<AboutBox productName={defaultTitleLogin} />);
  }

  @OnClick({ target: FooterAliases.LINK_DEPENDENCIES })
  onClickDependences(): void {
    const defaultTitleLogin = `${MessageService.translate('patient.welcome.landing.page')} ${MessageService.translate('patient.title.landing.page')}`;
    this.configureModalProps(<ManifestDependencies applicationName={defaultTitleLogin} />);
  }

  setFooterText = (layoutData: LayoutData): void => {
    if(layoutData.dsEmailRodape != null){
      this.emailText.setValue(layoutData.dsEmailRodape);
    }
    if(layoutData.nrFoneContato != null){
      this.phoneText.setValue(layoutData.nrFoneContato);
    }
    if(layoutData.dsEndereco != null){
      this.addressText.setValue(layoutData.dsEndereco);
    }
  }

  configureModalProps(children: ReactElement): void {
    const modalProps: BaseModalProps = {
      children,
      closeable: true,
      onClose: () => { return },
      theme: ThemeTonalRange.BRIGHT,
    }

    if (isMobile()) {
      ModalService.openFullscreen(modalProps);
    } else {
      ModalService.openDefault(modalProps);
    }
  }
}

export default FooterController;
